var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Emit, Prop } from "vue-property-decorator";
import { CaseVerifyService } from "~/services/domain-service/case-verify.service";
var CaseVerified = /** @class */ (function (_super) {
    __extends(CaseVerified, _super);
    function CaseVerified() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.model = {
            description: "",
        };
        //数据校验
        _this.rules = {
            description: [
                { required: true, message: "请输入申请说明", trigger: "blur" },
                { max: 500, message: "备注不能超过500字符", trigger: "blur" }
            ],
        };
        return _this;
    }
    CaseVerified.prototype.refreshData = function () { };
    CaseVerified.prototype.close = function () { };
    /**
     * 提交验证并并与数据库交互
     */
    CaseVerified.prototype.commit = function () {
        var _this = this;
        var verifyForm = this.$refs["verify-form"];
        verifyForm.validate(function (valid) {
            if (!valid)
                return;
            var caseIds = _this.selectionList.map(function (v) { return v.id; });
            var params = __assign(__assign({}, _this.model), { caseIds: caseIds });
            _this.caseVerifyService.verifiedCaseInfo(params)
                .subscribe(function (data) {
                _this.$message.success('批量核销成功');
                _this.refreshData();
                _this.close();
            });
        });
    };
    /**
     * 重置方法
     */
    CaseVerified.prototype.refresh = function () {
        var verifyForm = this.$refs["verify-form"];
        verifyForm.resetFields();
    };
    __decorate([
        Dependencies(CaseVerifyService)
    ], CaseVerified.prototype, "caseVerifyService", void 0);
    __decorate([
        Prop({ required: true, default: [] })
    ], CaseVerified.prototype, "selectionList", void 0);
    __decorate([
        Emit("refreshData")
    ], CaseVerified.prototype, "refreshData", null);
    __decorate([
        Emit("close")
    ], CaseVerified.prototype, "close", null);
    CaseVerified = __decorate([
        Component({
            components: {}
        })
    ], CaseVerified);
    return CaseVerified;
}(Vue));
export default CaseVerified;
